import axios from "./axiosConfig";

class BaseService {
  static async get(endpoint, token, params = {}, config = {}) {
    try {
      const response = await axios.get(endpoint, {
        headers: { 
          'Authorization': `Bearer ${token}`
        },
        params: params,
        ...config
      });
      return response;
    } catch (error) {
      console.error("Ocorreu um erro ao obter os dados!", error);
      throw error;
    }
  }

  static async post(endpoint, data, token, params = {}) {
    try {
      const response = await axios.post(endpoint, data, { 
        headers: { 
          'Authorization': `Bearer ${token}`
        },
        params: params
      });
      return response;
    } catch (error) {
      console.error("Ocorreu um erro ao postar os dados!", error);
      throw error;
    }
  }

  static async put(endpoint, id, data, token = null, params = {}) {
    try {
      console.log("params", params);
      const response = await axios.put(`${endpoint}/${id}`, data, { 
        headers: { 
          'Authorization': `Bearer ${token}`
        },
        params: params
      });
      return response;
    } catch (error) {
      console.error("Ocorreu um erro ao editar os dados!", error);
      throw error;
    }
  }

  static async delete(endpoint, id, token, params = {}) {
    try {
      const response = await axios.delete(`${endpoint}/${id}`, { 
        headers: { 
          'Authorization': `Bearer ${token}`
        },
        params: params
      });
      return response;
    } catch (error) {
      console.error("Ocorreu um erro ao excluir os dados!", error);
      throw error;
    }
  }
}

export default BaseService;